import { render, staticRenderFns } from "./ReturnBagOrdersList.vue?vue&type=template&id=cc56bf58&"
import script from "./ReturnBagOrdersList.vue?vue&type=script&lang=js&"
export * from "./ReturnBagOrdersList.vue?vue&type=script&lang=js&"
import style0 from "./ReturnBagOrdersList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports